import React from 'react';

import { PageHeader } from '../../components';
import styles from './ContactUs.module.scss';

const ArrowIcon = () => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='1.8'
    strokeLinecap='round'
    strokeLinejoin='round'
  >
    <path d='M7 17 17 7M9 7h8v8' />
  </svg>
);

const CONTACT_ROWS = [
  {
    href: 'tel:+94750100500',
    label: 'CUSTOMER CARE',
    value: '(+94) 750 100 500',
    icon: (
      <svg
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='1.8'
        strokeLinecap='round'
        strokeLinejoin='round'
      >
        <path d='M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2' />
      </svg>
    ),
  },
  {
    href: 'mailto:finance@thyaga.lk',
    label: 'EMAIL',
    value: 'finance@thyaga.lk',
    icon: (
      <svg
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='1.8'
        strokeLinecap='round'
        strokeLinejoin='round'
      >
        <rect x='3' y='5' width='18' height='14' rx='2' />
        <path d='m3 7 9 6 9-6' />
      </svg>
    ),
  },
  {
    href: 'https://maps.app.goo.gl/KLLuvVYC6py6QTveA',
    label: 'ADDRESS',
    value: '2A, Suleiman Terrace, Colombo 05',
    external: true,
    icon: (
      <svg
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='1.8'
        strokeLinecap='round'
        strokeLinejoin='round'
      >
        <path d='M12 21s7-6.5 7-11a7 7 0 1 0-14 0c0 4.5 7 11 7 11Z' />
        <circle cx='12' cy='10' r='2.5' />
      </svg>
    ),
  },
];

const ContactUs = () => {
  return (
    <div className={styles.root__div}>
      <PageHeader text='Contact Us' />

      <div className={styles.head}>
        <p className={styles.sub_title}>
          Reach the Thyaga team for account, technical, or operational help.
        </p>
      </div>

      <div className={styles.list}>
        {CONTACT_ROWS.map((row) => (
          <a
            key={row.label}
            className={styles.row}
            href={row.href}
            {...(row.external
              ? { target: '_blank', rel: 'noopener noreferrer' }
              : {})}
          >
            <span className={styles.left}>
              <span className={styles.icon} aria-hidden='true'>
                {row.icon}
              </span>
              <span>
                <span className={styles.label}>{row.label}</span>
                <span className={styles.value}>{row.value}</span>
              </span>
            </span>
            <span className={styles.arrow} aria-hidden='true'>
              <ArrowIcon />
            </span>
          </a>
        ))}
      </div>
    </div>
  );
};

export default ContactUs;
